"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const GaButton_1 = __importDefault(require("../../util/GaButton"));
const GDPRChoicesB2C_1 = __importDefault(require("./GDPRChoicesB2C"));
const GDPRChoicesB2B_1 = __importDefault(require("./GDPRChoicesB2B"));
const NotFound_1 = __importDefault(require("../NotFound"));
const lib_1 = require("@brandfree-front/lib");
const mobx_1 = require("mobx");
const DealerSigningNotice_1 = __importDefault(require("../notices/DealerSigningNotice"));
const StoresUtil_1 = require("../../util/StoresUtil");
const crm_components_1 = require("crm-components");
let GDPRChoices = class GDPRChoices extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "consentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dealerConsentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "partyPrivacyProfileStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signOnScreenClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                await this.partyPrivacyProfileStore.createPreparedOnScreenProfile();
                (0, crm_components_1.navigate)('/sign-on-screen');
            }
        });
        Object.defineProperty(this, "sendConfirmEvent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (window.self !== window.top) {
                    const message = this.consentStore.confirmError ? this.consentStore.confirmError : 'success';
                    window.parent.postMessage(message, '*');
                }
            }
        });
        Object.defineProperty(this, "sendCancelEvent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (window.self !== window.top) {
                    window.parent.postMessage('GdprCancelClicked', '*');
                }
            }
        });
    }
    render() {
        const { translate } = this.translateStore;
        const isError = this.consentStore.confirmError || this.dealerConsentStore.isError;
        const ErrorNotice = !isError
            ? () => react_1.default.createElement(react_1.default.Fragment, null)
            : () => (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(lib_1.Notice, { type: "attention" }, translate('global.server.error')),
                react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "xsmall" })));
        if (this.ssoStore.isPrivateCustomer) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ErrorNotice, null),
                react_1.default.createElement(GDPRChoicesB2C_1.default, { onConfirm: this.sendConfirmEvent, onCancel: this.sendCancelEvent }),
                this.getDealerButtons(),
                react_1.default.createElement("div", { "data-iframe-height": "" })));
        }
        if (this.ssoStore.isBusinessCustomer) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ErrorNotice, null),
                react_1.default.createElement(GDPRChoicesB2B_1.default, { onConfirm: this.sendConfirmEvent, onCancel: this.sendCancelEvent }),
                this.getDealerButtons(),
                react_1.default.createElement("div", { "data-iframe-height": "" })));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(NotFound_1.default, null),
            react_1.default.createElement("div", { "data-iframe-height": "" })));
    }
    getDealerButtons() {
        const { translate } = this.translateStore;
        const { isProfileGetLoading, hasChangedAgreements } = this.partyPrivacyProfileStore;
        if (!this.ssoStore.isDealer) {
            return null;
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "xsmall" }),
            react_1.default.createElement(lib_1.Grid, { align: ['center-xs'] },
                react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'md-10', 'lg-8'] },
                    react_1.default.createElement(DealerSigningNotice_1.default, null),
                    react_1.default.createElement(lib_1.Grid, { align: ['center-xs', 'middle-xs'] },
                        react_1.default.createElement(lib_1.GridColumn, { width: ['xs'] }, this.consentsOrProfileLoading() ? (react_1.default.createElement(lib_1.Spinner, null)) : (react_1.default.createElement(GaButton_1.default, { id: "sign-on-screen-button", onClick: this.signOnScreenClick, type: "employee", text: translate('gdpr.choices.signonscreen'), disabled: isProfileGetLoading || !hasChangedAgreements }))))))));
    }
    get hasChangedConsents() {
        return this.consentStore.changedConsents.length > 0;
    }
    consentsOrProfileLoading() {
        const { isProfileGetLoading, isProfileCreationLoading } = this.partyPrivacyProfileStore;
        return isProfileGetLoading || isProfileCreationLoading;
    }
};
__decorate([
    mobx_1.computed
], GDPRChoices.prototype, "hasChangedConsents", null);
GDPRChoices = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], GDPRChoices);
exports.default = GDPRChoices;
